import { FlowRouteCategory } from '@eneco/flows/types';

import { SummaryStep } from './steps/SummaryStep_D';
import { TestConfigVariant } from '../../types/experiment';

export const exp_n_522_D: TestConfigVariant = {
  testKey: 'exp-n-522-new-summary-step-layout',
  variant: 'D',
  routes: [
    {
      id: 'SUMMARY',
      path: '/je-gegevens/controle-keuze/',
      category: FlowRouteCategory.Summary,
      component: SummaryStep,
    },
  ],
};
